import { css } from '@emotion/core';
import { media, variables, tokens } from '@domain-group/fe-brary';
var font = variables.font,
  colour = variables.colour;
var colors = tokens.colors;
export var bodyTextBold = /*#__PURE__*/css("font-weight:", font.headingFontWeight, ";");
export var gotItButton = {
  name: "9ri52l",
  styles: "width:170px;height:40px;margin-bottom:14px;"
};
export var confirmButton = /*#__PURE__*/css("text-align:left;", media('>=tablet'), "{text-align:center;}");
export var errorMessageDetail = {
  name: "omcqsq",
  styles: "margin-bottom:7px;"
};
export var terms = /*#__PURE__*/css("color:", colour.neutral600, ";margin:20px 0 15px;font-size:", font.smallFontSize, ";line-height:18px;");
export var termsLink = /*#__PURE__*/css("font-size:", font.smallFontSize, ";padding:0;text-decoration:none;color:", colors.interactive.medium.default, ";&:hover{text-decoration:underline;color:", colors.interactive.medium.hover, ";}");
export var signUpFields = {
  name: "nm4xsv",
  styles: "&:last-child{margin-bottom:0;}"
};
export var logInButton = {
  name: "y8aj3r",
  styles: "padding:0;"
};